<template>
  <div class="error-jumbotron flex-1">
    <div class="flex items-center">
      <div class="flex-2 error-image">
        <img src="@/assets/image/404.png" alt />
      </div>
      <div class="flex-3 error-info">
        <h1>{{title}}</h1>
        <p>{{message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { httpGetNoToken } from "@/http/http";

export default {
  data() {
    return {
      title: null,
      message: null,
      queryId: null
    };
  },
  mounted: function() {
    this.$store.commit("closeSidebar");
    this.queryId = this.$route.query.id;
    if (this.queryId) {
      httpGetNoToken("set_not_follow_up", { consultantId: this.queryId }).then(
        response => {
          if (response.ok) {
            this.title = "Success";
            this.message = "You are taken out of the application process";
          } else {
            this.title = "Error";
            this.message = "error";
          }
        }
      );
    } else {
      this.title = "Error";
      this.message = "error";
    }
  }
};
</script>